module.exports = __webpack_public_path__ + "static/media/fr.0846f86e.svg";